import React, { useMemo } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useTheme } from './context/ThemeContext';
import getTheme from './styles/Theme';
import About from './pages/About';
import DashboardBis from './pages/DashboardBis';
import NotFound from './pages/NotFound';
import Settings from './pages/Settings';


const ETFIdentityFull = React.lazy(() => import('./pages/ETFIdentityFull'));
const SearchAlias = () => <Navigate to="/search" replace />;
const HomeAlias = () => <Navigate to="/" replace />;
const ETFDetailRoute = () => (
  <React.Suspense fallback={<div role="status">Chargement de la fiche ETF…</div>}>
    <ETFIdentityFull />
  </React.Suspense>
);

export default function App() {
  const { mode } = useTheme();
  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<DashboardBis />} />
        <Route path="/search" element={<DashboardBis />} />
        <Route path="/etf/:identifier" element={<ETFDetailRoute />} />
        <Route path="/etfidentity/:identifier" element={<ETFDetailRoute />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/about" element={<About />} />

        <Route path="/dashboard" element={<HomeAlias />} />
        <Route path="/etfsearch" element={<SearchAlias />} />
        <Route path="/etfai" element={<SearchAlias />} />
        <Route path="/semanticResearch" element={<SearchAlias />} />
        <Route path="/filtres-advanced" element={<SearchAlias />} />
        <Route path="/etfList" element={<SearchAlias />} />
        <Route path="/login" element={<HomeAlias />} />
        <Route path="/userportfolio/*" element={<HomeAlias />} />
        <Route path="/userAnalysis" element={<HomeAlias />} />
        <Route path="/userPerformance" element={<HomeAlias />} />
        <Route path="/userTransaction" element={<HomeAlias />} />
        <Route path="/userExport" element={<HomeAlias />} />
        <Route path="/userRebalancement" element={<HomeAlias />} />
        <Route path="/userAlert" element={<HomeAlias />} />
        <Route path="/userList" element={<HomeAlias />} />
        <Route path="/userConseils" element={<HomeAlias />} />
        <Route path="/userDividendes" element={<HomeAlias />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </MuiThemeProvider>
  );
}
